// extracted by mini-css-extract-plugin
module.exports = {"wave":"index-module__wave___Ix9UT"};